/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressIssueDTOFromJSON, AddressIssueDTOToJSON, } from './AddressIssueDTO';
import { SupplierDeliveryDTOFromJSON, SupplierDeliveryDTOToJSON, } from './SupplierDeliveryDTO';
/**
 * @export
 */
export const ExtensionOrderStatusDTOOrderStatusEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * @export
 */
export const ExtensionOrderStatusDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const ExtensionOrderStatusDTOTrackingCheckStatusEnum = {
    NoTracking: 'NO_TRACKING',
    Match: 'MATCH',
    Mismatch: 'MISMATCH'
};
/**
 * Check if a given object implements the ExtensionOrderStatusDTO interface.
 */
export function instanceOfExtensionOrderStatusDTO(value) {
    return true;
}
export function ExtensionOrderStatusDTOFromJSON(json) {
    return ExtensionOrderStatusDTOFromJSONTyped(json, false);
}
export function ExtensionOrderStatusDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'found': json['found'] == null ? undefined : json['found'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'purchaseConfirmedAt': json['purchaseConfirmedAt'] == null ? undefined : (new Date(json['purchaseConfirmedAt'])),
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'manualFulfillment': json['manualFulfillment'] == null ? undefined : json['manualFulfillment'],
        'shippinglotOrderId': json['shippinglotOrderId'] == null ? undefined : json['shippinglotOrderId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingUrl': json['trackingUrl'] == null ? undefined : json['trackingUrl'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'sentFromWarehouseDate': json['sentFromWarehouseDate'] == null ? undefined : (new Date(json['sentFromWarehouseDate'])),
        'amazonShipmentConfirmedAt': json['amazonShipmentConfirmedAt'] == null ? undefined : (new Date(json['amazonShipmentConfirmedAt'])),
        'lastAmazonShipmentError': json['lastAmazonShipmentError'] == null ? undefined : json['lastAmazonShipmentError'],
        'amazonTrackingNumbers': json['amazonTrackingNumbers'] == null ? undefined : json['amazonTrackingNumbers'],
        'shippinglotTrackingNumber': json['shippinglotTrackingNumber'] == null ? undefined : json['shippinglotTrackingNumber'],
        'trackingCheckStatus': json['trackingCheckStatus'] == null ? undefined : json['trackingCheckStatus'],
        'trackingCheckedAt': json['trackingCheckedAt'] == null ? undefined : (new Date(json['trackingCheckedAt'])),
        'supplierDelivery': json['supplierDelivery'] == null ? undefined : SupplierDeliveryDTOFromJSON(json['supplierDelivery']),
        'addressIssues': json['addressIssues'] == null ? undefined : (json['addressIssues'].map(AddressIssueDTOFromJSON)),
    };
}
export function ExtensionOrderStatusDTOToJSON(json) {
    return ExtensionOrderStatusDTOToJSONTyped(json, false);
}
export function ExtensionOrderStatusDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amazonOrderId': value['amazonOrderId'],
        'found': value['found'],
        'marketplace': value['marketplace'],
        'orderStatus': value['orderStatus'],
        'buyerOrderId': value['buyerOrderId'],
        'purchaseConfirmedAt': value['purchaseConfirmedAt'] == null ? undefined : ((value['purchaseConfirmedAt']).toISOString()),
        'packageStatus': value['packageStatus'],
        'manualFulfillment': value['manualFulfillment'],
        'shippinglotOrderId': value['shippinglotOrderId'],
        'trackingNumber': value['trackingNumber'],
        'trackingUrl': value['trackingUrl'],
        'carrierName': value['carrierName'],
        'sentFromWarehouseDate': value['sentFromWarehouseDate'] == null ? undefined : ((value['sentFromWarehouseDate']).toISOString()),
        'amazonShipmentConfirmedAt': value['amazonShipmentConfirmedAt'] == null ? undefined : ((value['amazonShipmentConfirmedAt']).toISOString()),
        'lastAmazonShipmentError': value['lastAmazonShipmentError'],
        'amazonTrackingNumbers': value['amazonTrackingNumbers'],
        'shippinglotTrackingNumber': value['shippinglotTrackingNumber'],
        'trackingCheckStatus': value['trackingCheckStatus'],
        'trackingCheckedAt': value['trackingCheckedAt'] == null ? undefined : ((value['trackingCheckedAt']).toISOString()),
        'supplierDelivery': SupplierDeliveryDTOToJSON(value['supplierDelivery']),
        'addressIssues': value['addressIssues'] == null ? undefined : (value['addressIssues'].map(AddressIssueDTOToJSON)),
    };
}
